import { GraduationCap } from "@phosphor-icons/react";
import { SectionLabel } from "@/components/shared/SectionLabel";
import { RevealText } from "@/components/shared/RevealText";
import { AnimatedSection } from "@/components/shared/AnimatedSection";
import { CATEGORIES } from "@/data/siteData";

export const WhoWeServe = () => (
  <section className="py-24 px-6 bg-cream">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-14">
        <SectionLabel>Who We Serve</SectionLabel>
        <RevealText
          as="h2"
          text="Supporting Schools Across Their Teaching Needs"
          className="font-heading text-3xl sm:text-4xl font-semibold text-navy tracking-tight leading-tight"
        />
        <p className="mt-5 text-slate text-base leading-relaxed">
          Categories of schools and institutions we position our recruitment support for.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {CATEGORIES.map((cat, i) => (
          <AnimatedSection
            key={cat}
            delay={i * 0.05}
            data-testid={`category-card-${i}`}
            className="border border-navy/10 rounded-xl p-6 bg-white hover:border-accent/40 hover:-translate-y-1 transition-all duration-300"
          >
            <GraduationCap size={22} weight="duotone" className="text-accent mb-3" />
            <p className="text-sm font-semibold text-navy">{cat}</p>
          </AnimatedSection>
        ))}
      </div>
    </div>
  </section>
);
